interface LiquidGlassProps<T extends React.ElementType = "div"> {
  as?: T;
  children: React.ReactNode;
  className?: string;
  radius?: string;
  disabled?: boolean;
}

export default function LiquidGlass<T extends React.ElementType = "div">({
  as,
  children,
  className = "",
  radius = "22px",
  disabled = false,
  ...props
}: LiquidGlassProps<T> &
  Omit<React.ComponentPropsWithoutRef<T>, keyof LiquidGlassProps<T>>) {
  const Component = as || "div";

  const glassClasses = disabled
    ? ""
    : `before:content-[''] before:absolute before:inset-0 before:-z-10 before:pointer-events-none
       before:shadow-[inset_3px_3px_0px_-3px_rgba(255,255,255,0.5),inset_-3px_-3px_0px_-3px_rgba(255,255,255,0.3),inset_0_0_2px_0.3px_rgba(255,255,255,0.5)]
       liquid-glass`;

  return (
    <Component
      className={`relative isolate overflow-hidden ${glassClasses} ${className}`}
      style={
        {
          "--liquid-glass-radius": radius,
          borderRadius: radius,
        } as React.CSSProperties & {
          "--liquid-glass-radius": string;
        }
      }
      {...props}
    >
      {children}
    </Component>
  );
}
